import Switch from 'react-switch';
import { Link } from 'react-router-dom';
import { Card, Form, Input } from 'reactstrap';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { userRoles } from '../../../../../shared';
import { toast } from 'react-toastify';

import * as Yup from 'yup';
import moment from 'moment';
import { useFormik } from 'formik';

import {
    addNewLabRequestReport,
    addNewLabRequestReportAux,
    deleteLabRequestReportAux,
    getLabRequestReportAuxs,
    getLabRequestReports,
    updateLabRequestReport,
    updateLabRequestReportAux
} from '../../../../../store/actions';
import { deleteApiCall, postApiCall } from '../../../../../services/mainServices';
import Table1 from '../../../../../components/Common/TableContainer';
import {Offsymbol, OnSymbol, requestStatus, statuses} from '../../../../../constants';
import { InfoModalTestReport } from '../../../../../components/Common/InfoModalTestReport';
import { TableItemDeleteModal } from '../../../../../components/Common/TableItemDeleteModal';
import { AnalysisRequestLastUpdate } from '../../../../../components/Common/AnalysisRequestLastUpdate';
import { AnalysisRequestSaveButton } from '../../../../../components/Common/AnalysisRequestSaveButton';
import { AnalysisRequestNotifyButton } from '../../../../../components/Common/AnalysisRequestNotifyButton';
import { ConfirmationModalTestReport } from '../../../../../components/Common/ConfirmationModalTestReport';
import { AnalysisRequestAddReportModal } from '../../../../../components/Common/AnalysisRequestAddReportModal';
import { AnalysisRequestEditReportModal } from '../../../../../components/Common/AnalysisRequestEditReportModal';
import { AnalysisRequestNewRegisterButton } from '../../../../../components/Common/AnalysisRequestNewRegisterButton';
import { AnalysisRequestScheduleReportModal } from '../../../../../components/Common/AnalysisRequestScheduleReportModal';
import { AnalysisRequestScheduleReportsButton } from '../../../../../components/Common/AnalysisRequestScheduleReportsButton';
import { BaseCustomButton } from '../../../../../shared';

export const LabCitecDetailsReports = ({ props, id, labRequest, updateReportStatus, status, generalStatus }) => {
    const formatDateString = (val) => {
        if (!val) return '';
        if (typeof val !== 'string') {
            return moment.utc(val).format('YYYY-MM-DD');
        }
        return val.substring(0, 10);
    };

    const [showModalAddReport, setShowModalAddReport] = useState(false);

    //Funciondes que neecesita el modal "TableItemDeleteModal"
    const [showModalDeleteItem, setShowModalDeleteItem] = useState(false);

    //Funciondes que neecesita el modal "TableItemDeleteModal"
    const [showModalEditItem, setShowModalEditItem] = useState(false);

    // Para el botón y el modal de la información exclusiva de laboratorio
    const [showModalFinalDateScheduleReport, setShowModalFinalDateScheduleReport] = useState(false);

    // Para el botón y el modal de el apartado de Informe Parcial
    const [disableSchedulePartialReportButton, setDisableSchedulePartialReportButton] = useState(false);

    // Para establecer los datos de la fila seleccionada para editar o eliminar
    const [rowInfo, setRowInfo] = useState();

    const [finalDateEditFunc, setFinalDateEditFunc] = useState(false);
    const [flag, setFlag] = useState(false);
    const [finalDate, setFinalDate] = useState();
    const [essaysStartedAt, setEssaysStartedAt] = useState();
    const [essaysEndedAt, setEssaysEndedAt] = useState();

    // Switches del apartado de Verificacion de resultados
    const [personal, setPersonal] = useState(false);
    const [printedRecord, setPrintedRecord] = useState(false);
    const [auxMaterials, setAuxMaterials] = useState(false);
    const [procedures, setProcedures] = useState(false);

    // Switches del apartado de Entrega de Resultados
    const [printedRecord2, setPrintedRecord2] = useState(false);
    const [printedRecord2Annexed, setPrintedRecord2Annexed] = useState(false);
    const [digitalRecord, setDigitalRecord] = useState(false);
    const [digitalRecordAnnexed, setDigitalRecordAnnexed] = useState(false);

    // Switches del apartado de Solicitud de informes parciales
    const [requiresPartialReport, setRequiresPartialReport] = useState(false);

    const [confirmationModal, setConfirmationModal] = useState(false);
    const [showInfoModal, setShowInfoModal] = useState(false);

    const role = (localStorage.getItem("authUser")) ? JSON.parse(localStorage.getItem("authUser"))?.role : ''

    // Este objeto es para crear el único registro que se necesita

    const [isUpdate, setIsUpdate] = useState(false);

    // Es para controlar el bloqueo del switch de informes parciales
    const [lock, setLock] = useState(false);

    const booleanValidation = React.useMemo(
      () => generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED,
      [generalStatus]
    );

    // * Redux
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getLabRequestReports(`?limit=20&page=0&labRequest=${id}`));
        dispatch(getLabRequestReportAuxs(`?limit=20&page=0&labRequest=${id}`));
    }, [])

    const {
        labRequestReports,
        labRequestReportAuxs,
        loadingAux,
        totalAux,
        currentPageAux,
    } = useSelector(state => ({

        labRequestReports: state.labRequestReportReducer.labRequestReports,
        labRequestReport: state.labRequestReportReducer.labRequestReport,

        labRequestReportAuxs: state.labRequestReportAuxReducer.labRequestReportAuxs,
        labRequestReportAux: state.labRequestReportAuxReducer.labRequestReportAux,
        loadingAux: state.labRequestReportAuxReducer.loading,
        totalAux: state.labRequestReportAuxReducer.total,
        currentPageAux: state.labRequestReportAuxReducer.currentPage,

    }), shallowEqual);
    // * Redux fin

    useEffect(() => {

        if (labRequestReports.length !== 0) {
            setFinalDate(formatDateString(labRequestReports[0]?.endedAt));

            setPersonal(labRequestReports[0]?.resourcePersonal);
            setPrintedRecord(labRequestReports[0]?.resourcePrint);
            setAuxMaterials(labRequestReports[0]?.resourceAuxiliaryMaterials);
            setProcedures(labRequestReports[0]?.resourceProcedures);
            setPrintedRecord2(labRequestReports[0]?.reportsDeliveryPrint);
            setPrintedRecord2Annexed(labRequestReports[0]?.reportsDeliveryReportPrint);
            setDigitalRecord(labRequestReports[0]?.reportsDeliveryDigital);
            setDigitalRecordAnnexed(labRequestReports[0]?.reportsDeliveryReportDigital);
            setRequiresPartialReport(labRequestReports[0]?.partialReportFlag);
            setFinalDateEditFunc(false);

            setEssaysStartedAt(formatDateString(labRequestReports[0]?.essaysStartedAt));
            setEssaysEndedAt(formatDateString(labRequestReports[0]?.essaysEndedAt));
        } else {
            setFinalDate(moment(new Date()).format('YYYY-MM-DD'));

            setPersonal(false);
            setPrintedRecord(false);
            setAuxMaterials(false);
            setProcedures(false);
            setPrintedRecord2(false);
            setPrintedRecord2Annexed(false);
            setDigitalRecord(false);
            setDigitalRecordAnnexed(false);
            setRequiresPartialReport(false);
            setFinalDateEditFunc(false);
            setEssaysStartedAt('');
            setEssaysEndedAt('');
        }

    }, [labRequestReports])

    const recarga = () => {
        window.location.reload();
    }

    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            id: (labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de informes')?.id),
            trackingStatus: (labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de informes')?.trackingStatus) ?? ''
        },
        validationSchema: Yup.object({
            trackingStatus: Yup.string().required("Defina el estatus"),
        }),
        onSubmit: async (values, { resetForm }) => {
            if (validation.values.trackingStatus === 'Autorizado' && (labRequestReports[0]?.resourcePersonal === false || labRequestReports[0]?.resourcePrint === false || labRequestReports[0]?.resourceAuxiliaryMaterials === false || labRequestReports[0]?.resourceProcedures === false)) {
                setShowInfoModal(true);
            } else if (validation.values.trackingStatus === 'Autorizado' && labRequestReports.length === 0) {
                setShowInfoModal(true);
            } else {
                if (validation.values.trackingStatus === 'Autorizado') {
                    try {
                        await postApiCall('calendared-records/calendared', { labRequest: id });
                        toast.success('Fecha de informe final calendarizada correctamente');
                    } catch (e) {
                        console.error('Error calendarizando informe:', e);
                    }
                } else {
                    try {
                        await deleteApiCall(`calendared-records/by-lab-request/${id}`);
                    } catch (e) {
                        console.error('Error al descalendarizar informe:', e);
                    }
                }
                updateReportStatus(values);
                setTimeout(recarga, 900);
            }

        },
    });
    const columns = React.useMemo(
        () => [
            {
                Header: 'ID',
                accessor: 'code',
                width: '10%',
            },
            {
                Header: 'Informes Parciales',
                accessor: 'name',
                width: '25%',
            },
            {
                Header: 'Edad',
                accessor: 'age',
                width: '20%',
            },
            {
                Header: 'Estatus Autorización',
                // accessor: 'authorizationStatus',
                width: '25%',
                Cell: ({ row }) => (
                    <div>
                        {row.original?.authorizationStatus === 'Autorizado' ?
                            <>
                                <div className='text-success'>{row.original?.authorizationStatus}</div>
                                <hr className='m-0 mb-1' style={{ height: 1 }} />
                                <span>Fecha de atención: </span> <span className='text-primary'> {row.original.datedAt ? formatDateString(row.original.datedAt) : '-'}</span>
                            </>
                            :
                            row.original?.authorizationStatus === 'Rechazado' ?
                                <div className='text-danger'>{row.original?.authorizationStatus}</div> :
                            row.original?.authorizationStatus === 'En Espera' ?
                                <div className='text-center' style={{color:'#1994EC'}} >{row.original?.authorizationStatus}</div> :
                                <div className='text-warning'>{row.original?.authorizationStatus}</div>}

                    </div>
                ),
            },
            {
                width: '15%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center row">
                        <BaseCustomButton
                            disabled={
                                (role === userRoles.technicalAdvisor) ||
                                (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)
                            }
                            color='primary'
                            outline
                            className="col-10 mb-2 p-1"
                            icon="mdi-lead-pencil mdi-18px"
                            label="Editar"
                            onClick={() => { onUpdate(row.original) }}
                        />
                        <BaseCustomButton
                            disabled={
                                (role === userRoles.laboratorist) || 
                                (role === userRoles.technicalAdvisor && status !== statuses.SENT_PENDING ) || 
                                (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)
                            }
                            color='danger'
                            outline
                            className='col-10 mb-2 p-1'
                            icon='mdi-delete mdi-18px'
                            label='Eliminar'
                            onClick={() => { onDelete(row.original) }}
                        />
                    </div>
                ),
            },
        ],
        [role, generalStatus, status]
    )

    // Aqui deben de ir las acciones para realizar el posteo a backend para el registro de un nuevo informe
    const RegisterModalRespInfoAddEditReport = (values) => {
        const createValues = {
            ...values,
            labRequest: id,
            datedAt: moment(new Date()).format('YYYY-MM-DD'),
            authorizationStatus: 'En Espera',
        }
        dispatch(addNewLabRequestReportAux(createValues));
        setRowInfo('');
    }

    const RegisterModalRespInfoEditReport = (values) => {
        const createValues = {
            ...values,
            id: rowInfo.id,
        }
        dispatch(updateLabRequestReportAux(createValues));
        setRowInfo('');
    }

    const onUpdate = (values) => {
        setRowInfo(values);
        setShowModalEditItem(true);
    }

    const onDelete = (values) => {
        setRowInfo(values);
        setShowModalDeleteItem(true);
    }
    const onDeleteConfirmation = () => {
        dispatch(deleteLabRequestReportAux(rowInfo));
        setRowInfo('');
    }

    const getPagination = (params) => {
        dispatch(getLabRequestReportAuxs(`${params}&labRequest=${id}`));
    }

    const onScheduleConfirmation1 = async () => {
        try {
            await postApiCall('calendared-records/calendared', { labRequest: id });
            toast.success('Fecha de informe final calendarizada correctamente');
        } catch (error) {
            toast.error('Error al calendarizar la fecha de informe final');
        }
    }

    const SaveInfo = () => {
        if (role !== userRoles.technicalAdvisor && (essaysStartedAt === '' || essaysEndedAt === '')) {
            setFlag(true)
        }
        else{
            if (labRequestReports.length === 0) { // Si no existe fecha no hay que mandar ese dato
                dispatch(addNewLabRequestReport(
                    {
                        labRequest: id,
                        endedAt: finalDate,
                        resourcePersonal: personal,
                        resourcePrint: printedRecord,
                        resourceAuxiliaryMaterials: auxMaterials,
                        resourceProcedures: procedures,
                        reportsDeliveryPrint: printedRecord2,
                        reportsDeliveryReportPrint: printedRecord2Annexed,
                        reportsDeliveryDigital: digitalRecord,
                        reportsDeliveryReportDigital: digitalRecordAnnexed,
                        partialReportFlag: requiresPartialReport,
                        essaysStartedAt: essaysStartedAt,
                        essaysEndedAt: essaysEndedAt,
                    }
                ));
            } else {
                dispatch(updateLabRequestReport(
                    {
                        id: labRequestReports[0]?.id,
                        labRequest: id,
                        endedAt: finalDate,
                        resourcePersonal: personal,
                        resourcePrint: printedRecord,
                        resourceAuxiliaryMaterials: auxMaterials,
                        resourceProcedures: procedures,
                        reportsDeliveryPrint: printedRecord2,
                        reportsDeliveryReportPrint: printedRecord2Annexed,
                        reportsDeliveryDigital: digitalRecord,
                        reportsDeliveryReportDigital: digitalRecordAnnexed,
                        partialReportFlag: requiresPartialReport,
                        essaysStartedAt: essaysStartedAt,
                        essaysEndedAt: essaysEndedAt,
                    }
                ));
            }
            setFlag(false)
        }

    }

    const onAccept = () => {
        validation.submitForm();
    }

    const editFinalDate = () => {
        setFinalDateEditFunc(!finalDateEditFunc);
    }

    const onHandleChageFinalDate = (e) => {
        setFinalDate(e.target.value);
    }

    const onHandleEssaysStartChangeDate = (e) => {
        setEssaysStartedAt(e.target.value);
    }

    const onHandleEssaysEndChangeDate = (e) => {
        setEssaysEndedAt(e.target.value);
    }

    return (
        <>
            <Form
                className="form-horizontal mt-2 mb-1"
                onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                }}
            >
                <div className='d-flex align-items-center pt-1 w-100'>
                    {/* Componente de última actualización */}
                    <AnalysisRequestLastUpdate client={`${labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de informes')?.updatedBy?.name ?? ''} ${labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de informes')?.updatedBy?.surname ?? ''}`}
                        date={`${moment(labRequest?.labRequestTracking?.find(x => x.subStepTracking === 'Validación de informes')?.updatedAt).format('YYYY-MM-DD HH:mm') ?? ''}`} />
                </div>
                {/* Botonera */}
                <div className='row align-items-end justify-content-end'>

                    {/* <AnalysisRequestStatusSelector disabled={(role === userRoles.technicalAdvisor)} /> */}

                    <div className='col-auto mx-1'>
                        <label className='text-primary'>Estatus</label>

                        <select
                            disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                            name="trackingStatus"
                            className="form-select text-primary rounded-3"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.trackingStatus || ""}
                        >
                            {requestStatus.map((dir, index) => {
                                return <option key={index} value={dir.id}>{dir.value}</option>
                            })}
                        </select>
                    </div>

                    <div className='col-auto'>
                        <button disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)} type='button' className='btn btn-primary rounded-3 d-flex align-items-center py-1 ms-1' onClick={() => setConfirmationModal(true)}>
                            <span className="mdi mdi-18px mdi-checkbox-marked-circle me-2"></span>Guardar Estatus
                        </button>
                        <ConfirmationModalTestReport props={props} onAccept={onAccept} showModal={confirmationModal} setShowModal={setConfirmationModal} message='¿Está seguro de cambiar el estatus de la solicitud de informes?' />
                        <InfoModalTestReport props={props} showModal={showInfoModal} setShowModal={setShowInfoModal} message='El proceso no se puede autorizar si la verificación de recursos no esta al 100 %' />
                    </div>

                    <div className='col-auto'>
                        {
                            booleanValidation ? <AnalysisRequestNotifyButton disabled={booleanValidation} />
                                : <Link
                                    to={{
                                        pathname: `/process-notification/${id}`,
                                    }}
                                  >
                                    <AnalysisRequestNotifyButton disabled={booleanValidation} />
                                  </Link>
                        }
                    </div>

                    <div className='col-auto'>
                        <AnalysisRequestSaveButton disabled={(role === userRoles.technicalAdvisor && status !== statuses.SENT_PENDING || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED))} handleOnClick={SaveInfo} />
                    </div>

                </div>
            </Form>
            <br />

            {
                <Card className='rounded-3' style={{ padding: 20 }}>

                    <div className='d-flex align-items-end justify-content-between'>
                        <label className='text-primary h6 me-2 mb-3'><u>Información exclusiva de laboratorio</u></label>
                        <div className='d-flex'>
                            <AnalysisRequestScheduleReportsButton disabled={(generalStatus === statuses.FINISHED) || (generalStatus === statuses.CANCELLED)} setShowModal={setShowModalFinalDateScheduleReport} text='Calendarizar Informe' />
                            <AnalysisRequestScheduleReportModal props={props} showModal={showModalFinalDateScheduleReport} setShowModal={setShowModalFinalDateScheduleReport} onScheduleConfirmation={onScheduleConfirmation1} modalHeader='Calendarizar informe' modalBodyLabel='Esta acción calendarizará la fecha de informe final, ¿Desea continuar?' />
                        </div>
                    </div>

                    <label className='text-success me-2 mb-1'>Fecha programada de informe final</label>
                    <hr className='m-0 mb-1' style={{ height: 1 }} />

                    {
                        (flag)?
                          <div className='row text-center'>
                              <div className='text-center text-danger'>
                                  <b>Asegurese de ingresar todas las fechas</b>
                              </div>
                          </div> : null
                    }

                    <div className='d-flex align-items-start'>
                        {
                            (role !== userRoles.technicalAdvisor) ?
                              <div>
                                  <label className='text-secondary mt-4'></label>
                                  <button
                                    disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                                    className='btn btn-primary d-flex align-items-center py-1 rounded-3 me-2'
                                    onClick={editFinalDate}
                                  >
                                      <span className="mdi mdi-18px mdi-calendar-multiple text-light me-2"></span>Editar Fecha
                                  </button>
                              </div>
                              : null
                        }
                        <div className='px-3'>
                            <label className='text-secondary mt-2'>Fecha de Informe Final</label>
                            {
                                (finalDateEditFunc)
                                  ?
                                  <Input
                                    disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                                    name="datetime1"
                                    className="form-control rounded-3 text-primary mb-4"
                                    type='date'
                                    onChange={onHandleChageFinalDate}
                                    value={formatDateString(finalDate)}
                                    // date={moment.format('YYYY-MM-DD')}
                                  />
                                  :
                                  (finalDate)
                                    ? <Input disabled={true} className="form-control rounded-3 text-primary mb-4" value={formatDateString(finalDate)} />
                                    : <Input disabled={true} className="form-control rounded-3 text-primary mb-4" value={'aaaa/mm/dd'} />
                            }

                            {/* <Input
                                    disabled={(role === userRoles.technicalAdvisor)}
                                    name="datetime1"
                                    className="form-control rounded-3 text-primary mb-4"
                                    type='date'
                                    id="LabCitecDetailsReportsinputFinalReportDate"
                                // date={moment.format('YYYY-MM-DD')}
                                /> */}
                        </div>
                        <div className='px-3'>
                             <label className='text-secondary mt-2'>Fecha de Inicio de Ensayos</label>
                            {
                                (finalDateEditFunc)
                                  ?
                                  <Input
                                    disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                                    name="datetime2"
                                    className="form-control rounded-3 text-primary mb-4"
                                    type='date'
                                    onChange={onHandleEssaysStartChangeDate}
                                    value={formatDateString(essaysStartedAt)}
                                    // date={moment.format('YYYY-MM-DD')}
                                  />
                                  :
                                  (essaysStartedAt)
                                    ? <Input disabled={true} className="form-control rounded-3 text-primary mb-4" value={formatDateString(essaysStartedAt)} />
                                    : <Input disabled={true} className="form-control rounded-3 text-primary mb-4" value={'aaaa/mm/dd'} />
                            }
                        </div>
                        <div className='px-3'>
                            <label className='text-secondary mt-2'>Fecha Final de Ensayos</label>
                            {
                                (finalDateEditFunc)
                                  ?
                                  <Input
                                    disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                                    name="datetime3"
                                    className="form-control rounded-3 text-primary mb-4"
                                    type='date'
                                    onChange={onHandleEssaysEndChangeDate}
                                    value={formatDateString(essaysEndedAt)}
                                    // date={moment.format('YYYY-MM-DD')}
                                  />
                                  :
                                  (essaysEndedAt)
                                    ? <Input disabled={true} className="form-control rounded-3 text-primary mb-4" value={formatDateString(essaysEndedAt)} />
                                    : <Input disabled={true} className="form-control rounded-3 text-primary mb-4" value={'aaaa/mm/dd'} />
                            }
                        </div>
                    </div>

                    {
                        (role !== userRoles.technicalAdvisor) ?
                          <>
                            <label className='text-success me-2 mb-1'>Verificación de recursos</label>
                            <hr className='m-0 mb-1' style={{ height: 1 }} />

                            <div className='d-flex justify-content-between w-50 mt-3'>

                                  <div className="">
                                      <label className='text-secondary me-2'>Personal</label>
                                      <Switch
                                        disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                                        uncheckedIcon={<Offsymbol />}
                                        checkedIcon={<OnSymbol />}
                                        onColor="#94C12E"
                                        onChange={() => { setPersonal(!personal) }}
                                        checked={personal}
                                      />
                                  </div>

                                  <div className="">
                                      <label className='text-secondary me-2'>Equipo e Instalaciones</label>
                                      <Switch
                                        disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                                        uncheckedIcon={<Offsymbol />}
                                        checkedIcon={<OnSymbol />}
                                        onColor="#94C12E"
                                        onChange={() => { setPrintedRecord(!printedRecord) }}
                                        checked={printedRecord}
                                      />
                                  </div>

                                  <div className="">
                                      <label className='text-secondary me-2'>Materiales Auxiliares</label>
                                      <Switch
                                        disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                                        uncheckedIcon={<Offsymbol />}
                                        checkedIcon={<OnSymbol />}
                                        onColor="#94C12E"
                                        onChange={() => { setAuxMaterials(!auxMaterials) }}
                                        checked={auxMaterials}
                                      />
                                  </div>

                                  <div className="">
                                      <label className='text-secondary me-2'>Procedimientos</label>
                                      <Switch
                                        disabled={(role === userRoles.technicalAdvisor) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                                        uncheckedIcon={<Offsymbol />}
                                        checkedIcon={<OnSymbol />}
                                        onColor="#94C12E"
                                        onChange={() => { setProcedures(!procedures) }}
                                        checked={procedures}
                                      />
                                  </div>

                              </div>
                          </>
                          : null
                    }
                </Card>
            }

            <Card className='rounded-3' style={{ padding: 20 }}>

                <div className='d-flex align-items-end justify-content-between'>
                    <label className='text-primary h6 me-2 mb-3'><u>Solicitud de resultados</u></label>
                    {/* <AnalysisRequestSaveButton handleOnClick={SaveResultsRequest} /> */}
                </div>



                <label className='text-success me-2 mb-1'>Entrega de resultados</label>
                <hr className='m-0 mb-1' style={{ height: 1 }} />


                <div className="row mt-3 w-50">

                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                        <label className='text-secondary'>Informe Impreso</label>
                    </div>

                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                        <Switch
                            disabled={(role === userRoles.laboratorist) || (role === userRoles.technicalAdvisor && status !== statuses.SENT_PENDING ) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                            uncheckedIcon={<Offsymbol />}
                            checkedIcon={<OnSymbol />}
                            onColor="#94C12E"
                            onChange={() => { setPrintedRecord2(!printedRecord2) }}
                            checked={printedRecord2}
                        />
                    </div>

                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                        <label className='text-secondary'>Informe Digital</label>
                    </div>

                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                        <Switch
                            disabled={(role === userRoles.laboratorist) || (role === userRoles.technicalAdvisor && status !== statuses.SENT_PENDING ) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                            uncheckedIcon={<Offsymbol />}
                            checkedIcon={<OnSymbol />}
                            onColor="#94C12E"
                            onChange={() => { setDigitalRecord(!digitalRecord) }}
                            checked={digitalRecord}
                        />
                    </div>

                </div>

                <div className="row mt-2 w-50">

                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                        <label className='text-secondary'>Anexos de informe impreso</label>
                    </div>

                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                        <Switch
                            disabled={(role === userRoles.laboratorist) || (role === userRoles.technicalAdvisor && status !== statuses.SENT_PENDING ) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                            uncheckedIcon={<Offsymbol />}
                            checkedIcon={<OnSymbol />}
                            onColor="#94C12E"
                            onChange={() => { setPrintedRecord2Annexed(!printedRecord2Annexed) }}
                            checked={printedRecord2Annexed}
                        />
                    </div>

                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                        <label className='text-secondary'>Anexos de informe digital</label>
                    </div>

                    <div className='col-12 col-sm-12 col-md-3 col-lg-3 col-xl-3 col-xxl-3'>
                        <Switch
                            disabled={(role === userRoles.laboratorist) || (role === userRoles.technicalAdvisor && status !== statuses.SENT_PENDING ) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                            uncheckedIcon={<Offsymbol />}
                            checkedIcon={<OnSymbol />}
                            onColor="#94C12E"
                            onChange={() => { setDigitalRecordAnnexed(!digitalRecordAnnexed) }}
                            checked={digitalRecordAnnexed}
                        />
                    </div>

                </div>

                <label className='text-success me-2 mb-1 mt-4'>Solicitud de informes parciales</label>
                <hr className='m-0 mb-1' style={{ height: 1 }} />

                <div className='d-flex justify-content-between w-50 mt-3'>

                    <div className="">
                        <label className='text-secondary me-4 pe-1'>Requiere Informe Parcial</label>
                        <Switch
                            disabled={lock || (role === userRoles.laboratorist) || (role === userRoles.technicalAdvisor && status !== statuses.SENT_PENDING ) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)}
                            uncheckedIcon={<Offsymbol />}
                            checkedIcon={<OnSymbol />}
                            onColor="#94C12E"
                            onChange={() => { setRequiresPartialReport(!requiresPartialReport) }}
                            checked={requiresPartialReport}
                        />
                    </div>

                </div>

                {
                    (requiresPartialReport)
                        ?
                        <>
                            <div className='d-flex align-items-end justify-content-end pt-3 px-5'>
                                <AnalysisRequestNewRegisterButton disabled={disableSchedulePartialReportButton || role === userRoles.laboratorist || (role === userRoles.technicalAdvisor && status !== statuses.SENT_PENDING ) || (generalStatus === statuses.FINISHED || generalStatus === statuses.CANCELLED)} setShowModal={setShowModalAddReport} text={'Agregar informe'} />
                                <AnalysisRequestAddReportModal props={props} modalRespInfo={RegisterModalRespInfoAddEditReport} showModal={showModalAddReport} setShowModal={setShowModalAddReport} modalHeader='Informes Parciales' />
                            </div>

                            <div className='px-5'>
                                <Table1 currentPage={currentPageAux} getPagination={getPagination} total={totalAux} loading={loadingAux} isAddTableBorderStrap columns={columns} data={labRequestReportAuxs} />
                                <AnalysisRequestEditReportModal props={props} showModal={showModalEditItem} setShowModal={setShowModalEditItem} modalRespInfo={RegisterModalRespInfoEditReport} modalHeader='Informes Parciales' rowInfo={rowInfo} setIsUpdate={setIsUpdate} />
                                <TableItemDeleteModal props={props} onDeleteConfirmation={onDeleteConfirmation} setShowModal={setShowModalDeleteItem} showModal={showModalDeleteItem} modalHeader='Eliminar Informe' modalBodyLabel='¿Está seguro que desea borrar el informe seleccionado?' />
                            </div>

                        </>
                        : null

                }

            </Card>
        </>
    )
}
